{
  "de": {
    "pagination": {
      "next": "Nächste Seite",
      "page_report": "Seite {page} von {total}",
      "previous": "Vorherige Seite",
      "report": "Zeigt {first} bis {last} von {total}",
      "total": "Gesamtzahl der Einträge: {total}"
    }
  }
}
